import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ManagerReport from './components/ManagerReport-Component/ManagerReport';
import LoginPage from './components/ManagerReport-Component/LoginPage';
import GuidLanding from './components/ManagerReport-Component/GuidLanding';
import SsoCallback from './components/ManagerReport-Component/SsoCallback';
import UserDeviceProvider from './components/DeviceInfo';
import { AuthProvider } from './contexts/AuthContext';

const App = () => {
    return (
        <UserDeviceProvider>
            <Routes>
                <Route path="/:databaseName/sso-callback" element={<SsoCallback />} />

                <Route
                    path="/login"
                    element={
                        <AuthProvider>
                            <LoginPage />
                        </AuthProvider>
                    }
                />
                <Route
                    path="/report"
                    element={
                        <AuthProvider>
                            <ManagerReport />
                        </AuthProvider>
                    }
                />
                <Route
                    path="/:coVal/:userVal"
                    element={
                        <AuthProvider>
                            <GuidLanding />
                        </AuthProvider>
                    }
                />
            </Routes>
        </UserDeviceProvider>
    );
};

export default App;
